import { Typography } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import * as React from "react"
import { useState } from "react"
import { Redirect } from "react-router"
import { AppRoutes } from "../../common/AppsRouter"
import { CCUtils } from "../../common/CCUtils"
import { FormWrapper } from "../generic-components/FormWrapper"
import { useForm } from "../hooks/useForm"
import { appTheme } from "../StyleUtils"
import { LoginRoutes } from "../WebApp"
import { AuthStoreSA } from "./AuthStoreSA"
import { LoginPage } from "./LoginPage"
import { StudentAccountStore } from "./StudentAccountStore"

export const StudentCreateScreenname = () => {
    const [isValid, setIsValid] = useState(false)
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState<boolean>(false)

    const validateAccount = async () => {
        setLoading(true)
        const isUnique = await StudentAccountStore.instance.isScreenNameUnique(inputs.screenname)
        if (isUnique) {
            StudentAccountStore.instance.screenname = inputs.screenname

            await AuthStoreSA.instance.createStudentAccount()

            setError(false)
            setIsValid(true)
        } else {
            setError(true)
            setLoading(false)
        }
    }

    const initialValue = {screenname: StudentAccountStore.instance.screenname}

    const {inputs, handleInputChange} = useForm(initialValue)

    if (StudentAccountStore.instance.classCode === "" && !isValid) {
        return <Redirect to={LoginRoutes.joinClass}/>
    }

    if (isValid) {
        StudentAccountStore.instance.clearStore()
        return <Redirect to={AppRoutes.activities} push={true}/>
    }

    const audioFile = CCUtils.asset("auth/register/create-screenname.mp3")

    return (
        <LoginPage title={"Create a <br/>Screen Name"} smallLogo={true}>
            <audio id="audio" src={audioFile} autoPlay/>
            <Typography variant={"body2"} style={{marginBottom: appTheme.spacing(4)}}>
                This screen name will be seen by all of your classmates and your teacher, so be careful about the name you choose. Pick a name that is
                easy to remember. Don’t use your real name. For example: batman or lucky1
            </Typography>
            <FormWrapper
                onClick={validateAccount}
                disabled={inputs.screenname.length === 0 || inputs.screenname.length > 25 || loading}
                buttonLabel={"Set Screen Name"}
                loading={loading}
            >
                <TextField
                    label={`Screen Name ${inputs.screenname.length}/25`}
                    name="screenname"
                    fullWidth={true}
                    autoFocus={true}
                    value={inputs.screenname}
                    onChange={handleInputChange}
                    error={error || inputs.screenname.length > 25}
                    helperText={error ? "That screen name is taken. Choose another screen name." : ""}
                />
            </FormWrapper>
        </LoginPage>
    )
}